
  import moment from "moment";
  import RentalDetail from '@/components/RentalDetail'
  export default {
    layout: 'direct-content',
    components: {
      RentalDetail
    },
    head() {
      return {
        title: this.title + " | Goa App",
        meta: [{
            hid: 'og:title',
            property: 'og:title',
            content: this.title + " | Goa App"
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: this.title + " | Goa App"
          }
        ],
      }
    },
    data() {
      return {
        title: 'rental detail',
        vehicleDetails: null,
        selectedDealData: null,
        selectedDeal: 0
      };
    },
    mounted() {
      if (localStorage.getItem("vehicleDetails") != (null || undefined)) {
        this.vehicleDetails = JSON.parse(localStorage.getItem("vehicleDetails"));
        if (this.vehicleDetails && this.vehicleDetails.deals && this.vehicleDetails.deals.length > 0) {
          this.selectedDealData = this.vehicleDetails.deals[0];
        }
      } else {
        return this.$nuxt.error({ statusCode: 404, message: "Error" })
        // this.$router.push({
        //   path: "/"
        // });
      }
    },
    methods: {
      goToCheckout() {
        if (this.selectedDealData) {
          this.$router.push({
            path: "/rental-checkout"
          });
        }
      }
    }
  }

